import { useMemo, useState } from 'react';
import { Dispatch, FunctionComponent } from 'react';
import { VoucherCheckoutState } from '../vouchersState';
import BlueprintIcon from '../../../../components/BlueprintIcon';
import Card from '../../../../components/Card';
import Button from '../../../../components/Button';
import ButtonLink from '../../../../components/ButtonLink';
import { useEducatorProfileLinks } from '../../../../hooks/useEducatorProfileLinks';
import { ShareLinks } from '../../../../components/ShareLinks';

import styles from './styles.module.scss';

const PrintVoucher: FunctionComponent<{ state: VoucherCheckoutState; resetPrint: () => void }> = ({
    state,
    resetPrint,
}) => {
    const params = new URLSearchParams({
        amount: state.amount.toString(),
        buyer: state.buyer.firstName || '',
        recipient: state.recipient.firstName || '',
        message: state.message || '',
        logo_url: state.educator.logo_url || '',
        cover_url: state.educator.cover_url || '',
        educator_name: state.educator.name,
        voucher_code: state.code || '',
        currency: state.educator.primaryCurrency,
    });

    return (
        <iframe
            src={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/gift-printout?${params.toString()}`}
            style={{ display: 'none' }}
            onLoad={() => {
                setTimeout(() => {
                    resetPrint();
                }, 1000);
            }}
        />
    );
};

export const Confirmation: FunctionComponent<{
    state: VoucherCheckoutState;
    dispatch: Dispatch<Partial<VoucherCheckoutState>>;
}> = ({ state, dispatch }) => {
    const [triggerPrint, setTriggerPrint] = useState(false);
    const { aboutLink, coursesLink } = useEducatorProfileLinks(state.educator.slug);

    const shareText = useMemo(() => {
        return `I just bought a voucher from ${state.educator.name}!`;
    }, [state.educator.name]);

    const shareUrl = useMemo(() => {
        return `${window.location.origin}${aboutLink}`;
    }, [aboutLink]);

    return (
        <div>
            <section
                className={styles.confirmationStepHeader}
                aria-labelledby="confirmation-step-header"
            >
                <BlueprintIcon icon={'CheckMarkCircle'} className={styles.confirmedIcon} />
                <h1 id="confirmation-step-header" className={styles.heading}>
                    Voucher Purchased
                </h1>
            </section>
            <Card>
                <h3 className={styles.heading}>Check your inbox for a confirmation email</h3>
                <span className={styles.voucherReference}>
                    Voucher reference: {state.voucherId}
                </span>
                <div className={styles.buttons}>
                    <ButtonLink href={coursesLink}>← Back to course list</ButtonLink>
                    <Button onClick={() => setTriggerPrint(true)}>Print Voucher</Button>
                    {triggerPrint ? (
                        <PrintVoucher
                            state={state}
                            resetPrint={() => {
                                setTriggerPrint(false);
                            }}
                        />
                    ) : null}
                </div>
            </Card>
            <ShareLinks
                shareText={shareText}
                shareLink={shareUrl}
                educatorFeatureFlags={state.educator.feature_flags}
            />
        </div>
    );
};
